import React from "react";
import { Result, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";

export default function ErrorPlaceholder({ error, onRetry, title = "Error loading keys" }) {
  return (
    <div className="h-full flex flex-col border border-gray-200 rounded-md">
      <div className="flex-grow flex items-center justify-center bg-red-50">
        <div className="text-center p-8 max-w-md w-full">
          <Result
            status="error"
            icon={<FontAwesomeIcon icon={faTriangleExclamation} style={{ color: "#cf1322", fontSize: 48 }} />}
            title={title}
            subTitle={typeof error === "string" ? error : "An unexpected error occurred while fetching keys."}
            extra={[
              <Button key="retry" type="primary" danger onClick={onRetry}>
                Retry
              </Button>,
            ]}
          />
        </div>
      </div>
    </div>
  );
}

ErrorPlaceholder.propTypes = {
  error: PropTypes.any,
  onRetry: PropTypes.func,
  title: PropTypes.string,
};